"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoveFocus = exports.HandleSubmit = exports.HandleSetter = exports.HandleOpen = exports.HandleClose = exports.BuildTestIdMap = void 0;
Object.defineProperty(exports, "SearchButton", {
  enumerable: true,
  get: function () {
    return _SearchButton.default;
  }
});
exports.default = void 0;
var SearchMethods = _interopRequireWildcard(require("./Search"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SearchButton = _interopRequireDefault(require("./SearchButton"));
var _Search2 = _interopRequireDefault(require("@mui/icons-material/Search"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("./../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _NavigationStyles = require("./../Navigation/NavigationStyles");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const merge = require("deepmerge"),
  BuildTestIdMap = testId => {
    return {
      component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
      box: (0, _string.isStringOfLength)(testId) ? `${testId}__popper` : undefined,
      form: (0, _string.isStringOfLength)(testId) ? `${testId}__form` : undefined,
      input: (0, _string.isStringOfLength)(testId) ? `${testId}__input` : undefined,
      submitButton: (0, _string.isStringOfLength)(testId) ? `${testId}__submit` : undefined,
      closeButton: (0, _string.isStringOfLength)(testId) ? `${testId}__close` : undefined,
      shadow: (0, _string.isStringOfLength)(testId) ? `${testId}__shadow` : undefined
    };
  },
  HandleClose = setter => {
    let result = false;
    if ((0, _function.isFunction)(setter)) {
      setter(null);
      result = true;
    }
    window.PubSub.publish("search.close");
    return result;
  },
  HandleOpen = (e, defaultAnchorId, anchorEl, setAnchorEl) => {
    const clickElement = (0, _string.isStringOfLength)(defaultAnchorId) ? document.getElementById(defaultAnchorId) : e.currentTarget;
    let resolvedValue = null;
    if ((0, _function.isFunction)(setAnchorEl)) {
      if (clickElement !== anchorEl) {
        resolvedValue = clickElement;
      }
      setAnchorEl(resolvedValue);
    }
    return resolvedValue;
  },
  HandleSetter = (value, setter) => {
    let result = null;
    if ((0, _function.isFunction)(setter)) {
      result = value;
      setter(value);
    }
    return result;
  },
  HandleSubmit = () => {
    return true;
  },
  MoveFocus = sQuery => {
    const searchInput = (0, _string.isStringOfLength)(sQuery) ? document.querySelector(sQuery) : null;
    if (searchInput && (0, _function.isFunction)(searchInput.focus)) {
      searchInput.focus();
    }
    return searchInput;
  };

/**
 * Search Popper Window, loosely coupled to Search Button component through PubSub Event
 *
 * @visibleName Search
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.MoveFocus = MoveFocus;
exports.HandleSubmit = HandleSubmit;
exports.HandleSetter = HandleSetter;
exports.HandleOpen = HandleOpen;
exports.HandleClose = HandleClose;
exports.BuildTestIdMap = BuildTestIdMap;
const Search = props => {
  if (!(0, _object.isObject)(window.PubSub)) {
    window.PubSub = require("pubsub-js");
  }
  const {
      ariaLabel = "Sitewide Search",
      ariaRole = "search",
      autoOpen = false,
      backgroundImagePath = `${process.env.PUBLIC_URL}/general/images/footer/Triangle-Pattern-042520-Blue.svg`,
      buttonId = "search__button-id",
      className,
      customTheme = {},
      defaultAnchorId,
      defaultSearchValue = "",
      placeholderText = "What can we help you find today?",
      popperBoxStyles = {},
      searchId = "search_form",
      styles = {},
      target = "_self",
      testId
    } = props,
    theme = merge((0, _styles.useTheme)(), customTheme),
    testIdMap = BuildTestIdMap(testId),
    [searchValue, setSearchValue] = (0, _react.useState)(defaultSearchValue),
    [anchorEl, setAnchorEl] = (0, _react.useState)(null),
    componentBoxStyles = merge.all([(0, _NavigationStyles.DefaultPopperBoxStyles)(theme), {
      padding: "0 3rem",
      position: "relative",
      width: "100%",
      "form": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        width: "100%"
      },
      ".Search__input": {
        border: `0.1rem solid ${theme.search.inputBorderColor}`,
        borderRadius: "0.5rem",
        fontFamily: theme.fontFamilies.semiBold,
        fontSize: "1.6rem",
        marginRight: "1.3rem",
        maxWidth: "84rem",
        padding: "1.4rem 1.8rem",
        width: "100%",
        "::placeholder": {
          color: theme.search.inputPlaceholderColor
        }
      },
      ".Search__submit": merge(theme.mixins.variantButtons.primary, {
        borderRadius: "0.5rem",
        height: "5rem",
        minWidth: "0",
        width: "6rem",
        "svg": {
          height: "3.5rem",
          width: "3.5rem"
        }
      }),
      ".Search__button-text": {
        clipPath: "inset(50%)",
        height: "1px",
        overflow: "hidden",
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px"
      },
      ".Search__close": {
        height: "2rem",
        right: "0.5rem",
        position: "absolute",
        top: "0",
        width: "2rem",
        "svg": {
          fill: theme.search.closeButtonColor
        }
      }
    }, popperBoxStyles]),
    componentStyles = merge.all([(0, _NavigationStyles.DefaultPopperStyles)(theme), {
      backgroundImage: `${theme.search.backgroundGradients},url("${backgroundImagePath}")`,
      backgroundSize: "75%",
      display: {
        xs: "flex",
        md: "flex"
      },
      justifyContent: "center",
      minHeight: "0",
      minWidth: theme.minWidth,
      paddingBottom: "2.5rem",
      paddingTop: "2.5rem"
    }, styles]),
    shadow = document.createElement("div"),
    searchClasses = (0, _classnames.default)({
      "Search": true,
      [`${className}`]: className
    }),
    handleChange = e => {
      SearchMethods.HandleSetter(e.target.value, setSearchValue);
    },
    handleClose = () => {
      SearchMethods.HandleClose(setAnchorEl);
    },
    handleOpen = (0, _react.useCallback)(e => {
      SearchMethods.HandleOpen(e, defaultAnchorId, anchorEl, setAnchorEl);
    }, [anchorEl, defaultAnchorId]);
  (0, _react.useEffect)(() => {
    shadow.className = "navigation__shadow";
    shadow.setAttribute("role", "presentation");
    shadow.setAttribute("aria-owns", buttonId);
    if (testIdMap.shadow) {
      shadow.setAttribute("data-testid", testIdMap.shadow);
    }
    if (anchorEl) {
      document.body.appendChild(shadow);
    } else {
      shadow.parentNode?.removeChild(shadow);
    }
    const token = window.PubSub.subscribe("search.open", handleOpen);
    return () => {
      shadow.parentNode?.removeChild(shadow);
      window.PubSub.unsubscribe(token);
    };
  }, [anchorEl, buttonId, handleOpen, shadow, testIdMap.shadow]);
  (0, _react.useEffect)(() => {
    if (autoOpen && (0, _string.isStringOfLength)(defaultAnchorId) && document.getElementById(defaultAnchorId)) {
      setAnchorEl(document.getElementById(defaultAnchorId));
      window.PubSub.publish("search.open", null);
    }
  }, [autoOpen, defaultAnchorId]);
  return /*#__PURE__*/_react.default.createElement(_material.ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/_react.default.createElement(_material.Popper, {
    anchorEl: anchorEl,
    "aria-owns": buttonId,
    className: searchClasses,
    "data-testid": testIdMap.component,
    onClose: handleClose,
    open: Boolean(anchorEl),
    popperOptions: {
      strategy: "fixed"
    },
    sx: componentStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": testIdMap.box,
    sx: componentBoxStyles
  }, /*#__PURE__*/_react.default.createElement("form", {
    action: "https://www.google.com/search",
    "aria-label": ariaLabel,
    "data-testid": testIdMap.form,
    id: searchId,
    method: "GET",
    onSubmit: SearchMethods.HandleSubmit,
    role: ariaRole,
    target: target
  }, /*#__PURE__*/_react.default.createElement("input", {
    "aria-labelledby": "Search__button-text",
    className: "Search__input",
    "data-testid": testIdMap.input,
    maxLength: "255",
    name: "q",
    onChange: handleChange,
    placeholder: placeholderText,
    required: true,
    size: "31",
    type: "search",
    value: searchValue
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    name: "as_sitesearch",
    value: window.location.hostname
  }), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: "Search__submit",
    name: "sa",
    type: "submit",
    "data-testid": testIdMap.submitButton
  }, /*#__PURE__*/_react.default.createElement(_Search2.default, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Search__button-text",
    component: "span",
    id: "Search__button-text"
  }, "Search"))), /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    className: "Search__close",
    onClick: handleClose,
    "data-testid": testIdMap.closeButton
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)))));
};
Search.propTypes = {
  /** String for search form's label */
  ariaLabel: _propTypes.default.string,
  /** String to indicate search form's aria role */
  ariaRole: _propTypes.default.string,
  /** Boolean to open window on load */
  autoOpen: _propTypes.default.bool,
  /** URL for Background Image (Default Value: "/general/images/footer/Triangle-Pattern-042520-Blue.svg") */
  backgroundImagePath: _propTypes.default.string,
  /** DOM ID for Button (Default Value: "search__button-id") */
  buttonId: _propTypes.default.string,
  /** Custom classname(s) */
  className: _propTypes.default.string,
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** DOM ID of node to position popper window against */
  defaultAnchorId: _propTypes.default.string,
  /** Default search value (Default Value: "") */
  defaultSearchValue: _propTypes.default.string,
  /** Placeholder Text (Default Value: "What can we help you find today?") */
  placeholderText: _propTypes.default.string,
  /** Custom styles for popper window (Default Value: {}) */
  popperBoxStyles: _propTypes.default.object,
  /** String for form ID value */
  searchId: _propTypes.default.string,
  /** Custom styles for component */
  styles: _propTypes.default.object,
  /** Target where search results will open (Default Value: "_self") */
  target: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = Search;